import { AsyncButton } from "aic";
import { handleCommentsSubscriptionDetails } from "functions/api/comments/handleCommentsSubscription";
import { IRequestStatus } from "functions/api/interface";
import { BellFill, BellSlashFill } from "react-bootstrap-icons";

interface CommentSubscriptionButtonProps {
  isSubscribed: boolean;
  toggleCommentsSubscription: () => void;
  toggleSubscriptionStatusRequest: IRequestStatus<handleCommentsSubscriptionDetails>;
}

/**
 * Button to toggle subscription status for comment notifications.
 *
 * @param props - Component props.
 * @param props.isSubscribed - Whether the user is subscribed to comments.
 * @param props.toggleCommentsSubscription - Callback to toggle subscription.
 * @param props.toggleSubscriptionStatusRequest - Request status for the toggle action.
 */
export const CommentSubscriptionButton = ({
  isSubscribed,
  toggleCommentsSubscription,
  toggleSubscriptionStatusRequest,
}: CommentSubscriptionButtonProps): React.ReactElement => {
  return (
    <AsyncButton
      id="comment-subscription-button"
      size="sm"
      onClick={(e) => {
        toggleCommentsSubscription();
        e.preventDefault();
        e.stopPropagation();
      }}
      title={isSubscribed ? "Unsubscribe from Comments notifications" : "Subscribe to comments"}
      requestStatus={toggleSubscriptionStatusRequest}
    >
      {isSubscribed ? (
        <>
          <BellSlashFill className="me-1" />
          Unsubscribe
        </>
      ) : (
        <>
          <BellFill className="me-1" />
          Subscribe
        </>
      )}
    </AsyncButton>
  );
};

CommentSubscriptionButton.displayName = "CommentSubscriptionButton";
